// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__32EIW","resendInfoText":"OnGoingPaymentBox_resendInfoText__2b5WC"};